import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { emitEvent } from '../../services/socketService';
import { showToast } from '../common/ToastContainer';

// TODO: Add optimistic updates

interface MessageInputProps {
    conversationId: number;
}

const MessageInput: React.FC<MessageInputProps> = ({ conversationId }) => {
    const [messageContent, setMessageContent] = useState('');
    const [isSending, setIsSending] = useState(false);

    const handleSendMessage = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!messageContent.trim() || isSending) return;

        const contentToSend = messageContent.trim();
        console.log(`Sending message to conversation ${conversationId}:`, contentToSend);
        setIsSending(true); 

        try {
            // Emit the event via socket service
            await emitEvent('sendMessage', { 
                content: contentToSend, 
                conversationId 
            });
            // Clear input on successful emission
            setMessageContent(''); 
        } catch (error) {
            console.error("Error sending message via socket:", error);
            showToast("Failed to send message. Please check connection.", "danger");
            // Optionally, don't clear the input on error
        } finally {
             setIsSending(false);
        }
    };

    return (
        <Form onSubmit={handleSendMessage}>
            <InputGroup>
                <Form.Control
                    as="textarea"
                    rows={1}
                    placeholder="Type a message..."
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    onKeyDown={(e) => {
                        // Optional: Send on Enter, Shift+Enter for newline
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSendMessage(e);
                        }
                    }}
                    style={{ resize: 'none' }}
                    disabled={isSending}
                />
                <Button type="submit" variant="primary" disabled={isSending || !messageContent.trim()}>
                    {isSending ? (
                       <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...</>
                    ) : (
                        <FontAwesomeIcon icon={faPaperPlane} />
                    )}
                </Button>
            </InputGroup>
        </Form>
    );
};

export default MessageInput; 